import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

// Render the React application into the root div
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
